import { EReducers } from '../../store/reducers';
import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { IReducers } from 'app/store/reducers';
import { FLASH_TYPE, IUserSessionData, UserState } from 'app/store/models/user.model';
import { UtilitiesService } from '../../store/services/utilities.servive';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../store/services/settings.service';
import { Router } from '@angular/router';
import { setFlash, setSignature } from '../../store/actions/user.action';
import { openSnackbar } from '../../store/actions/page.action';
import { ButtonDisablerService } from '../../store/services/button-disabler.service';

@Component({
  selector: 'app-set-signature',
  templateUrl: './set-signature.component.html',
  styleUrls: ['./set-signature.component.scss'],
})
export class SetSignatureComponent implements OnInit {
  userData: IUserSessionData;
  initialSignature = '';
  signatureForm: FormGroup;
  private hasSavedSignature: boolean;

  constructor(
    private store: Store<IReducers>,
    private utils: UtilitiesService,
    private settingsService: SettingsService,
    private router: Router,
    private readonly buttonDisabler: ButtonDisablerService,
  ) {
    this.store.select(EReducers.USER).subscribe((userState: UserState) => {
      if (userState.sessionData) {
        this.userData = userState.sessionData;

        if (this.userData.signature) {
          this.initialSignature = this.userData.signature;
          this.hasSavedSignature = true;
        } else {
          this.initialSignature = `<b>${this.userData.first_name} ${this.userData.last_name}</b><br>`;
          if (this.userData.phone_number) {
            this.initialSignature += `${this.userData.phone_number}<br>`;
          }

          if (this.userData.address1) {
            this.initialSignature += `${this.userData.address1}<br>`;
          }

          if (this.userData.address2) {
            this.initialSignature += `${this.userData.address2}<br>`;
          }

          if (this.userData.city) {
            this.initialSignature += `${this.userData.city}`;
          }

          if (this.userData.state) {
            this.initialSignature += `, ${this.utils.getStateName(
              this.userData.state,
            )}`;
          }

          if (this.userData.zip) {
            this.initialSignature += ` ${this.userData.zip}`;
          }
        }
      }
    });
  }

  onCancelClick = () => {
    this.router.navigate(['/contents']);
  };

  onSaveClick = () => {
    if (this.signatureForm.valid) {
      this.settingsService
        .updateSignature(
          this.userData.id,
          this.signatureForm.get('signature').value,
          this.signatureForm.get('content_signature').value,
        )
        .subscribe(() => {
          this.store.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  message: 'Signature successfully updated!',
                  type: 'success',
                },
                verticalPosition: 'bottom',
              },
            }),
          );
          this.store.dispatch(
            setSignature({
              signature: this.signatureForm.get('signature').value,
            }),
          );
          if (!this.hasSavedSignature) {
            this.store.dispatch(
              setFlash({
                data: {
                  type: FLASH_TYPE.ALERT,
                  alertMessage: 'Welcome to Retreva',
                },
              }),
            );
          }

          this.router.navigate(['/']);
        });
    } else {
      this.signatureForm.markAllAsTouched();
      this.buttonDisabler.disableActive();
    }
  };

  onEditorInit() {
    this.signatureForm.get('signature').setValue(this.initialSignature);
  }

  ngOnInit() {
    this.signatureForm = new FormGroup({
      signature: new FormControl(this.initialSignature, [Validators.required]),
      content_signature: new FormControl(true),
    });
  }

  formatPhoneNumber(value: string, group: number[], delimer = null) {
    let result = '';
    let lastPosition = 0;
    for (const gr of group) {
      result += value.substr(lastPosition, gr);
      if (delimer && gr !== group[group.length - 1]) {
        result += delimer;
      }

      lastPosition = gr;
    }

    return result;
  }
}
